import { cn } from "@/lib/utils";
import ExportedImage from "next-image-export-optimizer";
import { useEffect } from "react";
import { ComponentGeneralImage, Maybe, UploadFileEntityResponse } from "types/strapi";
import { getAltTextFromGeneralImage, getImageUrlFromGeneralImage } from "utils/imageHelpers";

type ChatButtonProps = {
    id: number;
    disabled?: boolean;
    onClick?: () => void;
    children: React.ReactNode;
    emoji: Maybe<UploadFileEntityResponse>;
    emojiAlt: Maybe<string>;
};


const ChatButton: React.FC<ChatButtonProps> = ({ id, children, emoji, emojiAlt, onClick, disabled }) => {

    const buttonEmojiObj: ComponentGeneralImage = {
        __typename: "ComponentGeneralImage",
        altText: emojiAlt,
        id: id.toString(),
        image: emoji,
        imageHD: null,
    };

    if (!children) return null;

    return (
        <button onClick={onClick} disabled={disabled} className={cn(
            "ChatButton | font-frutigerRoman font-bold",
            "rounded-full overflow-hidden text-[12px]",
            "border-[0.85px] border-white",
            "shadow-[0_0_13.33px_0_rgba(255,255,255,0.30),inset_0_0_20px_8px_rgba(255,255,255,0.6),inset_0_0.66px_5.34px_0_rgba(255,255,255,0.35)] py-[5px] px-[14px]",
            "text-shadow-chat-button flex gap-[8px]"
        )}>
            {children}
            {emoji && emojiAlt && (
                <div className="relative 4k:h-[90px] h-[20px] 4k:w-[90px] w-[20px]">
                    <ExportedImage
                        src={
                            emoji
                                ? getImageUrlFromGeneralImage(buttonEmojiObj)
                                : "No image provided"
                        }
                        alt={
                            emojiAlt
                                ? getAltTextFromGeneralImage(buttonEmojiObj)
                                : "No image provided"
                        }
                        layout="fill"
                    />
                </div>
            )}
        </button>
    );
};

export default ChatButton;


